import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AUTHENTICATED_HTTP_CLIENT } from '../../../constants';
import { ThreadCreationModel, ThreadModel } from '../../../models';
import { Observable } from 'rxjs';

@Injectable()
export class ThreadApiService {
  private static resourceName = 'threads';

  constructor(@Inject(AUTHENTICATED_HTTP_CLIENT) private httpClient: HttpClient) {}

  getAllThreads(): Observable<ThreadModel[]> {
    return this.httpClient.get<ThreadModel[]>(ThreadApiService.resourceName);
  }

  getThreadById(threadId: string): Observable<ThreadModel> {
    return this.httpClient.get<ThreadModel>(`${ThreadApiService.resourceName}/${threadId}`);
  }

  createThread(thread: ThreadCreationModel): Observable<ThreadModel> {
    return this.httpClient.post<ThreadModel>(ThreadApiService.resourceName, thread);
  }

  updateThread(thread: ThreadModel): Observable<ThreadModel> {
    return this.httpClient.put<ThreadModel>(`${ThreadApiService.resourceName}/${thread.id}`, thread);
  }

  bulkResolve(threadIds: string[]): Observable<ThreadModel[]> {
    return this.httpClient.post<ThreadModel[]>(`${ThreadApiService.resourceName}/resolve`, {
      ids: threadIds,
    });
  }

  bulkActivate(threadIds: string[]): Observable<ThreadModel[]> {
    return this.httpClient.post<ThreadModel[]>(`${ThreadApiService.resourceName}/activate`, {
      ids: threadIds,
    });
  }

  bulkDelete(threadIds: string[]): Observable<any> {
    return this.httpClient.post<ThreadModel[]>(`${ThreadApiService.resourceName}/delete`, {
      ids: threadIds,
    });
  }

  deleteThread(threadId: string): Observable<unknown> {
    return this.httpClient.delete(`${ThreadApiService.resourceName}/${threadId}`);
  }
}
